export enum PublicSections {
  // GENERAL DATA
  GET_ACTIVITIES = 'public-get-activities',
  GET_ACTIVITIES_BY_MAP = 'public-get-activities-map',
  GET_ACTIVITIES_BY_MAP_ALL = 'public-get-activities-map-all',
  GET_INFO_ACTIVITY = 'public-activity-info',
  GET_FEATURED_ACTIVITIES = 'public-get-featured-activities',
  UPDATE_VISIT_COUNT_ACTIVITY = 'public-visit-count',
  GET_EXTRA_ACTIVITIES = 'public-get-extra-activities',
  GET_MEDIUM_POSTS = 'public-get-medium',
  GET_MEDIUM_POSTS_ERRORS = 'errors.medium.public-get-medium',
  GET_THEMES_PUBLISHED = 'public-themes-published',
  GET_ACTIVITIES_SUBTHEMES = 'public-activities-subtheme',
  PRESS_RELEASE = 'get-press-releases',
}
